import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Loading, Button } from "Components";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import { migrateUser } from "Redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import ForgotPwdLink from "../common/ForgotPwdLink";
import ChatWithSupport from "../common/ChatWithSupport";
import { useLocation } from 'react-router-dom';
import { NotificationManager } from 'Components/Notifications';

import {
  migrateUserConfirmResult,
  forgotPasswordConfirm,
  clearRedux
} from 'Redux/actions';
import { validateStrongPassword } from "../../data/Helpers";
const FormMigrate = ({ current_reseller, username, email, confirmationCode, isResetPassword }) => {
  const frmMigrateUser = useRef();
  const { messages } = useIntl();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  
  const { loading } = useSelector((state) => state.migrateUserRedux);
  const { loading: loadingSignIn } = useSelector((state) => state.loginRedux);
  const { result: forgotPawordResult, loading: forgotPasswordLoading } = useSelector((state) => state.forgotPasswordRedux);

  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [txtConfirmPassword, setTxtConfirmPassword] = useState("");

  useEffect(() => {
    if (forgotPawordResult) {
      NotificationManager.success(
        messages["migrateUser_passwordReset"],
        messages["success"],
        3500,
        null,
        null,
        "success"
      )
      setError(null);
      dispatch(clearRedux("FORGOT_PASSWORD"));
      navigate('/login');
    }
    
  }, [forgotPawordResult]);

  return (
    <Form
      ref={frmMigrateUser}
      onSubmit={() => {
        
        if(!validateStrongPassword(password)){
          setError(messages['accountChangePassword_passwordValidation']);
          return false
        } 
        return true
      }}
      onValidSubmit={() => {
        setError(null);
        if(password != txtConfirmPassword){
          dispatch(migrateUserConfirmResult(false, messages['migrateUser_passwordDoesNotMatch']))
        } else {
          if(isResetPassword){
            dispatch(forgotPasswordConfirm(
              email,
              confirmationCode,
              password,
              txtConfirmPassword
            ));
            
          } else {
            dispatch(migrateUser(username, confirmationCode, password, navigate));
          }
          
        }
      }}
    >
    {(loading || forgotPasswordLoading || loadingSignIn) ? (
            <div className="loading-area">
              <Loading />
            </div>
    ) : (
      <>
        <div>
          <Input
            id="txtUsername"
            disabled
            type="text"
            className="txt-username"
            label={""}
            placeholder={messages["migrateUser_currentUsername"]}
            value={username || email}
            onChange={() => { }}
            required
            requiredMessage={messages["required_field"]}
            autoFocus
          />
        </div>
        <div>
          <Input
            id="txtPassword"
            label={""}
            placeholder={messages["migrateUser_password"]}
            value={password}
            type="password"
            onChange={(text) => {
              setPassword(text);
            }}
            required
            requiredMessage={messages["required_field"]}
            autoFocus
          />
        </div>
        <div>
          <Input
            id="txtConfirmPassword"
            type="password"
            label={""}
            placeholder={messages["migrateUser_confirmPassword"]}
            value={txtConfirmPassword}
            onChange={(text) => {
              setTxtConfirmPassword(text);
            }}
            required
            requiredMessage={messages["required_field"]}
            autoFocus
          />
        </div>
        <div style={{ paddingTop: 10 }}>
          {loading ? (
            <div className="loading-area">
              <Loading />
            </div>
          ) : (
            <Button
              id="btnContinue"
              className="btn btn-blue btn-block"
              disabled={loading}
              onClick={(e) => {
                e.preventDefault();
                frmMigrateUser.current.submit();
              }}
            >
              {messages["migrateUser_login"]}
            </Button>
          )}
        </div>
        {
          error &&
          <div style={{ marginTop: 10 }}>
            <small className="text-danger" style={{ paddingTop: 5 }}>
              {error}
            </small>
          </div>
        }
        <div style={{ paddingTop: 10 }}>
          <Button
            id="btnBack"
            className="btn btn-gray btn-block"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
          >
            {messages["migrateUser_cancel"]}
          </Button>
        </div>
        <Box style={{ margin: "25px 0 0 0" }}>
          <ForgotPwdLink current_reseller={current_reseller} />
        </Box>
        <Box style={{ margin: "5px 0 0 0" }}>
          <ChatWithSupport />
        </Box>
      </> 
    )}
    </Form>
  );
};

export default FormMigrate;
